var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination-links__wrapper"},[(_vm.nextLink)?_c('a',{attrs:{"href":_vm.nextLink}},[_vm._v("Next")]):_vm._e(),_vm._v(" "),(_vm.previousLink)?_c('a',{attrs:{"href":_vm.previousLink}},[_vm._v("Previous")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }